<script setup>
    import { onMounted } from 'vue';
    import { useUserStore } from '@/stores/user';
    import { useRouter } from 'vue-router';

    const userStore = useUserStore();
    const router = useRouter();

    onMounted(() => {
        // MSAL redirect handling and user bootstrapping already happen in
        // router/routes.js (msalReady + the beforeEach guard) before this
        // component can ever mount, so there is nothing left to do here but
        // continue on to the dashboard.
        router.push({ name: 'Dashboard' });
    });
</script>

<template>  
    <container>
        <div class="loader-overlay">
            <div class="loader" id="loader"></div>
            <div class="loadingDescription">Du wirst eingeloggt</div>
        </div>
    </container>
</template>